import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import { Divider } from "@material-ui/core";
import GetJobId from "../../../_utilities/GetJobId";
import { Notescall } from "../../../Icons/Notescall";
import AddApplicantsNotes from "./AddApplicantsNotes";
import { useDispatch, useSelector } from "react-redux";
import { Notesemail } from "../../../Icons/Notesemail";
import { EditingIcon } from "../../../Icons/Editing-Icon";
import { getUserDetails } from "../../../_utilities/getUserInfo";
import { GetTimeZone } from "../../../_utilities/GetTimeZone";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";
import EditIcon from "@mui/icons-material/Edit";

import "./ApplicantsNotes.css";
import { PublicView } from "../../../Icons/publicView";
import { PersionView } from "../../../Icons/persionView";

const initalState = { data: null, message: "", isloader: true };

const ApplicantsNotes = () => {
  const [user, setUser] = useState([]);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [isLoadDoc, setIsLoadDoc] = useState(false);
  const [noteState, setNoteState] = useState("");
  const [selectedNote, setSelectedNote] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);
  const [showNoData, setShowNoData] = useState(false);

  const dispatch = useDispatch();
  const getJobId = GetJobId();

  useEffect(() => {
    if (getJobId !== null) {
      Getdata();
    }
  }, [getJobId]);

  const notesData = useSelector((state) => state.ListNotes.data);
  const notesCode = useSelector((state) => state.ListNotes.code);
  const showLoader = useSelector((state) => state.Loader.value);

  useEffect(() => {
    if (notesCode === 404) {
      setIsValidUser(true);
    }
  }, [notesCode]);

  useEffect(() => {
    let timer;
    if (user.length === 0 && !showLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 1000);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [user, showLoader]);

  const Getdata = async () => {
    const userInfo = await getUserDetails();
    setUserDetails(userInfo);
    dispatch(_ser.listNotesAsync(getJobId));
  };

  useEffect(() => {
    if (notesData !== null) {
      let data = JSON.parse(JSON.stringify(notesData));
      setUser(data);
      setIsLoadDoc(false);
      dispatch(_ser.listNotesStartReducer(initalState));
    }
  }, [notesData]);

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    setIsLoadDoc(load);
    if (load === true) {
      setTimeout(() => {
        Getdata();
      }, 1200);
    }
    var element = document.getElementsByTagName("body");
    element[0].style.overflow = "";
  };

  const notesHandler = (type, data) => {
    setIsRightSidePannel(true);
    setNoteState(type);
    setSelectedNote(type === "Create" ? null : data);
    var element = document.getElementsByTagName("body");
    element[0].style.overflow = "hidden";
  };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <>
      {!isValidUser && (
        <div
          className="addnotessection"
          style={{ display: "flex", gap: "10px", marginTop: "-75px" }}
          onClick={() => {
            notesHandler("Create", null);
          }}
        >
          <DashboardPlusicon width={35} height={36} />
          <h4 className="addnotetext"> Notes </h4>
        </div>
      )}
      <div>
        {user.length > 0 && (
          <>
            {user.map((elem, i) => {
              return (
                <>
                  <div style={{ position: "relative" }}>
                    <div className="usericon">
                      {elem.noteType === "Call" ? (
                        <Notescall
                          secondaryColor={storedTheme?.secondaryColor}
                          secondaryFontColor={storedTheme?.secondaryFontColor}
                          width={40}
                          height={40}
                        />
                      ) : 
                      (elem.noteType === "Public" && elem.moduleType === "projects")? (
                        <PersionView
                          primaryColor={storedTheme?.secondaryColor}
                          primaryFontColor={storedTheme?.secondaryFontColor}
                          width={40}
                          height={40}
                        />
                      ):elem.noteType === "Public"? (
                        <PublicView
                          secondaryColor={storedTheme?.secondaryColor}
                          secondaryFontColor={storedTheme?.secondaryFontColor}
                          width={40}
                          height={40}
                        />
                      ) : (
                        <Notesemail
                          secondaryColor={storedTheme?.secondaryColor}
                          secondaryFontColor={storedTheme?.secondaryFontColor}
                          width={40}
                          height={40}
                        />
                      )}
                    </div>
                    <div className="jobnote" style={{ marginLeft: "80px" }}>
                      <b>
                        {elem.firstName + " " + elem.lastName}
                        {elem.noteType === "Public" && elem.moduleType === "projects" ? null : (
                          <span style={{ fontWeight: "normal", fontSize: "14px", color: "#616161", marginLeft: "8px" }}>
                            ({elem.noteType === "Call" ? "Call" : elem.noteType === "Public" ? "Public" : "E-mail"})
                          </span>
                        )}
                       
                      </b>
                      <div
                        style={{ maxWidth: "calc(100% - 150px)" }}
                        dangerouslySetInnerHTML={{ __html: elem.notes }}
                      ></div>
                      <div style={{ display: "flex",  gap: "4px" }}>
                       {elem.noteType === "Public" && (elem.projectName || elem.projectCode) && (
                          <span className="createdDate" style={{  color: storedTheme?.secondaryColor }}>
                           {elem.projectName || elem.projectCode},
                          </span>
                        )}
                      <span className="createdDate">
                        {elem.updatedAt ? `Last Updated : ${GetTimeZone(elem.updatedAt)}` : GetTimeZone(elem.createdAt)}
                      </span>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "30px",
                        right: "20px",
                      }}
                    >
                      {elem.userId === userDetails.userId ? (
                        <IconButton
                          color="primary"
                          onClick={() => {
                            notesHandler("Update", elem);
                          }}
                          component="label"
                        >
                          <EditIcon
                            sx={{ color: storedTheme?.secondaryColor }}
                            className="appediticon1"
                          />
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <Divider className="secline" />
                </>
              );
            })}
          </>
        )}
        {!showLoader && user?.length === 0 && (
          <div className="detail-card-empty">
            <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="No data"
            />
            No notes found
          </div>
        )}
      </div>

      <div className="contentSection">
        {isRightSidePannel ? (
          <AddApplicantsNotes
            onReceivePropsHandler={onReceivePropsHandler}
            noteState={noteState}
            selectedNote={selectedNote}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ApplicantsNotes;
